import script from "./HeaderWazzup.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderWazzup.vue?vue&type=script&setup=true&lang=js"

import "./HeaderWazzup.vue?vue&type=style&index=0&id=832912d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-832912d0"]])

export default __exports__